import { defineMessages } from 'react-intl';

const translations = {
  properties: {
    amount: {
      id: 'properties.amount',
      defaultMessage: 'Amount',
      description: 'label of the amount property',
    },
    calculation: {
      id: 'properties.calculation',
      defaultMessage: 'Calculation',
      description: 'label of the calculation property',
    },
    transaction: {
      id: 'properties.transaction',
      defaultMessage: 'Transaction',
      description: 'label of the transaction property',
    },
    isSettlement: {
      id: 'properties.isSettlement',
      defaultMessage: 'Settlement',
      description: 'label of the is settlement property',
    },
    payment: {
      id: 'properties.payment',
      defaultMessage: 'Payment',
      description: 'label of the payment property',
    },
  },
  chip: {
    isPaid: {
      id: 'properties.isPaid',
      defaultMessage: 'Paid',
      description: 'label of the is paid chip',
    },
    open: {
      id: 'properties.open',
      defaultMessage: 'Open',
      description: 'label of the open chip',
    },
  },
};

export default defineMessages(translations);
